import { useMemo } from 'react';

import useBooleanState from '~/hooks/useBooleanState';
import { CollectionRankingDesyncPopup } from '~/views/CollectionView/CollectionRanking/CollectionRankingDialogs/CollectionRankingDesyncPopup';
import { CollectionRankingInfoDialog } from '~/views/CollectionView/CollectionRanking/CollectionRankingDialogs/CollectionRankingInfoDialog';
import { CollectionRankingRadarPopup } from '~/views/CollectionView/CollectionRanking/CollectionRankingDialogs/CollectionRankingRadarPopup';
import { CollectionTopRankingPopup } from '~/views/CollectionView/CollectionRanking/CollectionRankingDialogs/CollectionTopRankingPopup';
import { CollectionUserRankPopup } from '~/views/CollectionView/CollectionRanking/CollectionRankingDialogs/CollectionUserRankPopup';
import { CollectionRanking } from '~/views/CollectionView/CollectionRanking/index';

type TCollectionRankingWithDialogsProps = {
  collectionId: string;
  collectionName: string;
  collectionValue: number;
};

export function CollectionRankingWithDialogs({
  collectionId,
  collectionName,
  collectionValue,
}: TCollectionRankingWithDialogsProps): JSX.Element {
  const [
    isInfoDialogOpened,
    { setTrue: openInfoDialog, setFalse: closeInfoDialog },
  ] = useBooleanState();
  const [
    isTopRankingPopupOpened,
    { setTrue: openTopRankingPopup, setFalse: closeTopRankingPopup },
  ] = useBooleanState();
  const [
    isUserRankingPopupOpened,
    { setTrue: openUserRankingPopup, setFalse: closeUserRankingPopup },
  ] = useBooleanState();
  const [
    isRankingDesyncPopupOpened,
    { setTrue: openDesyncPopupOpened, setFalse: closeDesyncPopupOpened },
  ] = useBooleanState();
  const [
    isChatRadarOpened,
    { setTrue: openChatRadar, setFalse: closeChatRadar },
  ] = useBooleanState();

  const openMethods = useMemo(
    () =>
      ({
        infoDialog: openInfoDialog,
        topRankingDialog: openTopRankingPopup,
        userRankingDialog: openUserRankingPopup,
        rankingDesyncDialog: openDesyncPopupOpened,
      } as const),
    [
      openDesyncPopupOpened,
      openInfoDialog,
      openTopRankingPopup,
      openUserRankingPopup,
    ],
  );

  return (
    <>
      {isRankingDesyncPopupOpened && (
        <CollectionRankingDesyncPopup
          collectionId={collectionId}
          close={closeDesyncPopupOpened}
          collectionName={collectionName}
          animateRootPopup={
            !isTopRankingPopupOpened && !isUserRankingPopupOpened
          }
        />
      )}
      {isChatRadarOpened && (
        <CollectionRankingRadarPopup
          close={closeChatRadar}
          collectionName={collectionName}
        />
      )}
      {isTopRankingPopupOpened && (
        <CollectionTopRankingPopup
          close={closeTopRankingPopup}
          openChatRadarDialog={openChatRadar}
          collectionName={collectionName}
          collectionId={collectionId}
          userCollectionValue={collectionValue}
          openRankingDesyncDialog={openMethods.rankingDesyncDialog}
        />
      )}
      {isUserRankingPopupOpened && (
        <CollectionUserRankPopup
          close={closeUserRankingPopup}
          openChatRadarDialog={openChatRadar}
          collectionName={collectionName}
          collectionId={collectionId}
          userCollectionValue={collectionValue}
          openRankingDesyncDialog={openMethods.rankingDesyncDialog}
        />
      )}
      {isInfoDialogOpened && (
        <CollectionRankingInfoDialog
          onClose={closeInfoDialog}
          collectionName={collectionName}
        />
      )}
      <CollectionRanking
        collectionId={collectionId}
        collectionValue={collectionValue}
        openMethods={openMethods}
      />
    </>
  );
}
